import { deepestChild } from '../helpers';

class Header {
  constructor() {
    this.sel = {
      component: '.header',
      umbrellaNav: '.header__umbrella',
      navLink: '.hasSublevel',
      rootLevel: '.rootlevel',
      headerLogo: '.header__logo',
      navicon: '.navicon',
      navigation: '.navigation',
      navWrapper: '.navigation__wrapper',
      backLevelOne: '.navigation__backbtnone',
      backLevelTwo: '.navigation__backbtntwo',
      overlayPanel: '.overlayPanel',
      warningPanelClose: '.warningPanel__closeButton',
      warningPanel: '.warningPanel',
      navCloseClass: '.overlay',
    };

    this.headerFixedClass = 'header--fixed';
    this.overlayPanelFixedClass = 'overlayPanel--headerfixed';
    this.navOpenClass = 'navigation--open';

    this.init = this.init.bind(this);
    this.openInitialLevel = this.openInitialLevel.bind(this);
    this.getStartPointLevel = this.getStartPointLevel.bind(this);
    this.bindEvents = this.bindEvents.bind(this);
    this.toggleNav = this.toggleNav.bind(this);
    this.gotoNextLevel = this.gotoNextLevel.bind(this);
    this.goBack = this.goBack.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  getStartPointLevel() {
    const $root = $(this.sel.component).find(this.sel.rootLevel);
    if ($root.find('li.startPoint').length <= 0) return 0;

    const $selected = deepestChild($root[0], 'li.startPoint');
    if (!$selected) return 0;

    const $level = $selected.closest('div');
    if ($level == null) return 0;

    let level = 0;
    $level.classList.forEach((className) => {
      switch (className) {
        case 'sublevelTwo':
          level = 2;
          break;
        case 'sublevelOne':
          level = 1;
          break;
        // no default
      }
    });
    return level;
  }

  openInitialLevel() {
    const $nav = $(this.sel.navigation);
    const level = this.getStartPointLevel();

    if (level <= 0) {
      $nav.scrollLeft(0);
      $nav.removeClass('navigation--showInNav');
      return;
    }

    // Each sub-panel sits at `left: 100vw` relative to its containing block
    // (`.rootlevel`, which is `position: relative`). `.rootlevel` itself is
    // inset from `.navigation` by the wrapper's margin-left + padding-left
    // (Bootstrap `.container`). So the true panel offset from `.navigation` is:
    //   wrapperMarginLeft + wrapperPaddingLeft + level * 100vw
    //
    // We can't rely on getBoundingClientRect at this moment because
    // `.rootlevel` is mid-animation (rootSlideinMobile, 500ms) — `left` goes
    // from -300px to 0, which visually moves absolutely-positioned children
    // and would give incorrect measurements. Using getComputedStyle on the
    // static wrapper avoids that timing dependency.
    const wrapperEl = $(this.sel.navWrapper)[0];
    let wrapperOffset = 0;
    if (wrapperEl) {
      const cs = window.getComputedStyle(wrapperEl);
      wrapperOffset = (parseFloat(cs.marginLeft) || 0) + (parseFloat(cs.paddingLeft) || 0);
    }
    const target = Math.round(wrapperOffset + level * window.innerWidth);

    $nav.addClass('navigation--showInNav');
    $nav.scrollLeft(target);
  }

  bindEvents() {
    this.gotoNextLevel();
    this.toggleNav();
    $(window).on('scroll', this.handleScroll);
    $(document).on('click', this.sel.backLevelOne, this.goBack);
    $(document).on('click', this.sel.backLevelTwo, this.goBack);

    $(document).on('click', this.sel.warningPanelClose, (evt) => {
      evt.preventDefault();
      const $warningPanel = $(evt.currentTarget).closest(this.sel.warningPanel);

      sessionStorage.setItem(`hidewarning-${$warningPanel.attr('data-warning-id')}`, true);
      $warningPanel.hide();
    });

    // show warning Panels that havent been added to cookies.
    $('[data-warning-id]').each((_, item) => {
      const storedWarningKey = `hidewarning-${$(item).attr('data-warning-id')}`;
      if (!sessionStorage[storedWarningKey]) {
        $(item).removeClass('v-hidden d-none');
      }
    });
  }

  gotoNextLevel() {
    $(document).on('click', this.sel.navLink, (e) => {
      if ($(e.target).hasClass('hasSublevel')) {
        $(e.target).siblings().removeClass('selected');
        $(e.target).siblings().children().find('.selected').removeClass('selected');
        $(e.target).addClass('selected');
        // The scroll animation for mobile resolution, the desktop version won't scroll.
        // Use window.innerWidth (not $(document).width()) because document width
        // can exceed the viewport due to off-screen sub-panels at left: 100vw.
        const leftPos = $(this.sel.navigation).scrollLeft();
        $(this.sel.navigation).animate(
          {
            scrollLeft: leftPos + window.innerWidth,
          },
          500,
        );
        setTimeout(() => {
          $(this.sel.navigation).removeClass('navigation--showInNav');
        }, 300);
      }
    });
  }

  toggleNav() {
    $('.overlay, .navicon').on('click', () => {
      if ($(this.sel.navicon).hasClass('open')) {
        $(this.sel.navicon).removeClass('open');
        $(this.sel.navigation).slideUp(0, () => {
          $(this.sel.component).removeClass('header--open');
          $(this.sel.navigation).removeClass(this.navOpenClass);
          $('body').css('overflow', 'auto');
          $(this.sel.navCloseClass).removeClass('overlay--open');
        });
        return;
      }
      $(this.sel.navicon).addClass('open');
      $(this.sel.component).addClass('header--open');
      $(this.sel.navigation).addClass(this.navOpenClass);
      $(this.sel.navigation).slideDown(0, () => {
        // Position to the active startPoint AFTER nav is actually visible.
        // Doing this earlier (or while display:none) causes the browser to
        // reset scrollLeft to 0.
        this.openInitialLevel();
      });
      $('body').css('overflow', 'hidden');
      $(this.sel.navCloseClass).addClass('overlay--open');
    });
  }

  goBack() {
    const leftPos = $(this.sel.navigation).scrollLeft();
    $(this.sel.navigation).animate(
      {
        scrollLeft: leftPos - window.innerWidth,
      },
      500,
    );
    setTimeout(() => {
      $(this.sel.navigation).removeClass('navigation--showInNav');
    }, 300);
  }

  handleScroll() {
    if ($(window).scrollTop() > 0) {
      $(this.sel.component).addClass(this.headerFixedClass);
      if ($(this.sel.overlayPanel).length) {
        $(this.sel.overlayPanel).addClass(this.overlayPanelFixedClass);
      }
      return;
    }
    $(this.sel.component).removeClass(this.headerFixedClass);
    $(this.sel.overlayPanel).removeClass(this.overlayPanelFixedClass);
  }

  init() {
    this.bindEvents();
  }
}

export default new Header();
